import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { initializeIcons } from "@fluentui/react/lib/Icons";

import { DynamicThemeProvider } from "./global/themes";
import { AuthenticationProvider } from "./global/authentication";
import { GoogleOAuthProvider } from '@react-oauth/google';

initializeIcons();

ReactDOM.render(
  <React.StrictMode>
    <AuthenticationProvider>
      <DynamicThemeProvider>
      <GoogleOAuthProvider clientId="1093338029790-138gb8gheas0ntod052drqi55a2fehje.apps.googleusercontent.com">
        <App />
    </GoogleOAuthProvider>
      </DynamicThemeProvider>
    </AuthenticationProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
